import React, { useEffect, useRef, useState } from 'react'
import styles from './CallRecordingsPlayer.module.css'
import { IoIosClose } from 'react-icons/io'

interface CallRecordingsPlayerProps {
    setShowCallRecordings: React.Dispatch<React.SetStateAction<boolean>>,
    audioUrl: string,
    setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>,
    callbackFunction: (handlePlayPause: () => void) => void
}

const CallRecordingsPlayer: React.FC<CallRecordingsPlayerProps> = ({ setShowCallRecordings, audioUrl, setIsPlaying, callbackFunction }) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [isAudioReady, setIsAudioReady] = useState(false);

    const closeRecordPlayerHandler = () => {
        if (audioRef.current) {
            audioRef.current.pause();
        }
        setShowCallRecordings(false)
        setIsPlaying(false)
    }

    const onLoadedMetadata = () => {
        if (audioRef.current) {
            setIsAudioReady(true);
        }
    };

    const handlePlayPause = () => {
        if (audioRef.current) {
            if (audioRef.current.paused) {
                audioRef.current.play();
                setIsPlaying(true);
            } else {
                audioRef.current.pause();
                setIsPlaying(false);
            }
        }
    };



    useEffect(() => {
        if (audioRef.current) {
            setIsPlaying(!audioRef.current.paused);
        }
    }, [audioUrl]);

    useEffect(() => {
        callbackFunction(handlePlayPause);
    }, []);

    return (
        <div className={styles.CallRecordingPlayerOverlay}>
            <div className={styles.CallRecordingPlayerWrapper}>
                <div className={styles.audioPlayerContainer}>
                    <audio 
                        ref={audioRef} 
                        controls 
                        autoPlay 
                        onLoadedMetadata={onLoadedMetadata}
                        onPlay={() => setIsPlaying(true)}
                        onPause={() => setIsPlaying(false)}
                    >
                        <source src={audioUrl} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </div>
                <div className={styles.CallRecordingPlayerClose} onClick={closeRecordPlayerHandler}>
                    <IoIosClose size={24} color="#606060" /> Close player
                </div>
            </div>
        </div>
    )
}

export default CallRecordingsPlayer;
